import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	Input,
	Output,
	EventEmitter
} from '@angular/core';
import {
	FormBuilder,
	FormGroup,
	Validators,
	FormControl,
	AbstractControl,
	FormArray
} from '@angular/forms';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { ApiService } from 'projects/services/src/app/API/api.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import * as $ from 'jquery';
declare var toastr: any;
declare var swal: any;
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';

import { Helpers } from 'projects/training-calendar/src/app/helpers';

import { TcTpCreationService } from 'projects/services/src/app/API/tc-tp-creation.service';
import { TcRuleDetail } from 'src/app/interfaces';
@Component({
	selector: 'app-tc-registration-rule-form',
	templateUrl: './tc-registration-rule-form.component.html',
	styleUrls: ['./tc-registration-rule-form.component.css']
})
export class TcRegistrationRuleFormComponent implements OnInit {
	items: any;
	@ViewChild('startDate') effectiveDate: ElementRef;
	@Input() isAdmin: any = false;
	@Input() tcRuleCreationForm: FormGroup;
	@Input() tcRuleDetails: TcRuleDetail;
	@Input() redirectCancelUrl: string;
	@Output() onSubmit = new EventEmitter();
	// tcRuleDetails: TCRuleCreation = new TCRuleCreation()

	// tcRuleCreationForm: FormGroup;
	loggedInUser: any;
	approved: boolean;
	notApproved: boolean;
	private comments: string;
	ruleId: string;
	adminFormGroup: FormGroup;
	tcTypeFormGroup: FormGroup;
	rulesForType: any = {
		type: '',
		accredation: {
			amount: null,
			isPaymentRequired: ''
		},
		continuousMonitoring: {
			isPaymentRequired: '',
			amount: null
		},
		unBlocking: {
			isPaymentRequired: '',
			amount: null
		},
		perJobRoleAffiliation: {
			isPaymentRequired: '',
			amount: null
		},
		appeal: {
			isPaymentRequired: '',
			amount: null
		}
	};
	constructor(
		private formBuilder: FormBuilder,
		private apiService: ApiService,
		private router: Router,
		private currentUserService: CurrentUserService,
		private scriptLoaderService: ScriptLoaderService,
		private tcTpCreationService: TcTpCreationService
	) {
		this.loggedInUser = this.currentUserService.decodeToken();
		this.tcRuleDetails = {
			adminRole: 'gegsdedtr',
			review: [],
			refundRules: {
				percentageOnRefusalOfCenterInspection: [
					{
						noOfDaysBeforeInspectionDate: 7.0,
						percentage: null
					},
					{
						noOfDaysBeforeInspectionDate: 3.0,
						percentage: null
					},
					{
						noOfDaysBeforeInspectionDate: 0.0,
						percentage: null
					}
				],
				refundOnDNRIfTCDoesnotReapply: null,
				refundOnSecondDNRIfTCDoesnotReapply: null
			},
			rulesForType: [
				{
					type: 'Reg',
					accredation: {
						amount: null,
						isPaymentRequired: ''
					},
					continuousMonitoring: {
						isPaymentRequired: '',
						amount: null
					},
					unBlocking: {
						isPaymentRequired: '',
						amount: null
					},
					perJobRoleAffiliation: {
						isPaymentRequired: '',
						amount: null
					},
					appeal: {
						isPaymentRequired: '',
						amount: null
					}
				},
				{
					type: 'Govenment',
					accredation: {
						amount: null,
						isPaymentRequired: ''
					},
					continuousMonitoring: {
						isPaymentRequired: '',
						amount: null
					},
					unBlocking: {
						isPaymentRequired: '',
						amount: null
					},
					perJobRoleAffiliation: {
						isPaymentRequired: '',
						amount: null
					},
					appeal: {
						isPaymentRequired: '',
						amount: null
					}
				}
			],
			actionsAndNotifications: {
				durationOfBlock: null,
				noOfDaysInAdvanceInspectionDateNotifications: null,
				noOfDaysForOnsiteInspectionAfterDeemedReady: null,
				noOfDaysForInspectionAgencyReplyBackOnAssessment: null,
				noOfBlockAttempts: null
			},
			effectiveDate: ''
		};
		this.tcRuleCreationForm = this.formBuilder.group({
			adminRole: ['', []],
			// comments: ['', []],
			status: ['', []],
			percentageOnRefusalOfCenterInspection: [
				'',
				[
					Validators.required,
					Validators.pattern('^(([0-9]{1,3})|([0-9]{1,2}[.][0-9]{1,2}))'),
					Validators.maxLength(5),
					Validators.minLength(1),
					Validators.max(100),
					Validators.min(0)
					// ValidationService.percentageValidator(),
					// ValidationService.number(5, true)
				]
			],
			percentageOnRefusalOfCenterInspection1: [
				'',
				[
					Validators.required,
					Validators.pattern('^(([0-9]{1,3})|([0-9]{1,2}[.][0-9]{1,2}))'),
					Validators.maxLength(5),
					Validators.minLength(1),
					Validators.max(100),
					Validators.min(0)
					// ValidationService.percentageValidator(),
					// ValidationService.number(3, true)
				]
			],
			percentageOnRefusalOfCenterInspection2: [
				'',
				[
					Validators.required,
					Validators.pattern('^(([0-9]{1,3})|([0-9]{1,2}[.][0-9]{1,2}))'),
					Validators.maxLength(5),
					Validators.minLength(1),
					Validators.max(100),
					Validators.min(0)
					// ValidationService.percentageValidator(),
					// ValidationService.number(3, true)
				]
			],
			refundOnDNRIfTCDoesnotReapply: [
				'',
				[
					Validators.required,
					Validators.pattern('^(([0-9]{1,3})|([0-9]{1,2}[.][0-9]{1,2}))'),
					Validators.maxLength(5),
					Validators.minLength(1),
					Validators.max(100),
					Validators.min(0)
					// ValidationService.percentageValidator(),
					// ValidationService.number(3, true)
				]
			],
			refundOnSecondDNRIfTCDoesnotReapply: [
				'',
				[
					Validators.required,
					Validators.pattern('^(([0-9]{1,3})|([0-9]{1,2}[.][0-9]{1,2}))'),
					Validators.maxLength(5),
					Validators.minLength(1),
					Validators.max(100),
					Validators.min(0)
					// ValidationService.percentageValidator(),
					// ValidationService.number(3, true)
				]
			],
			// /^[0-9]+(\.[0-9]{1,2})?$/
			// /^([1-9]{1,5}[.][0-9]{0,2})$/g

			// govtAccredationAmount: [null, [Validators.pattern('^(([0-9]{1,5})|([0-9]{1,5}[.][0-9]{2}))$')]],
			// govtAccredationAmount: ['', []],
			// govtAccredationAmountIsRequired: ['', [Validators.required, Validators.maxLength(8),
			// Validators.minLength(1)]],
			// regularAccredationAmount: ['', []],
			// regularAccredationAmountIsRequired: ['', [Validators.required]],
			// govtContinuousMonitoringAmount: ['', []],
			// govtContinuousMonitoringAmountIsRequired: [
			// 	'',
			// 	[Validators.required]
			// ],
			// regularContinuousMonitoringAmount: ['', []],
			// regularContinuousMonitoringAmountIsRequired: [
			// 	'',
			// 	[Validators.required]
			// ],
			// govtUnblockingAmount: ['', []],
			// govtUnblockingAmountIsRequired: ['', [Validators.required]],
			// regularUnblockingAmount: ['', []],
			// regularUnblockingAmountIsRequired: ['', [Validators.required]],
			// govtAffilationAmount: ['', []],
			// govtAffilationAmountIsRequired: ['', [Validators.required]],
			// regularAffilationAmount: ['', []],
			// regularAffilationAmountIsRequired: ['', [Validators.required]],
			durationOfBlock: [
				'',
				[Validators.required,
				// ValidationService.number(1, true),
				Validators.pattern('^[0-9]{0,2}$'),
				Validators.min(0),
				Validators.maxLength(2),
				// Validators.minLength(1),
				// Validators.min(0),
				Validators.max(12)]
			],
			noOfDaysInAdvanceInspectionDateNotifications: [
				'',
				[Validators.required,
				Validators.pattern('^[0-9]{1,3}$'),
				Validators.maxLength(3),
				// Validators.minLength(1),
				// ValidationService.number(6, true),
				Validators.min(0),
				Validators.max(365)]
			],
			noOfDaysForOnsiteInspectionAfterDeemedReady: [
				'',
				[Validators.required,
				Validators.pattern('^[0-9]{1,2}$'),
				Validators.maxLength(2),
				// Validators.minLength(1),
				// ValidationService.number(6, true)]
				Validators.min(0),
				Validators.max(30)]
			],
			noOfDaysForInspectionAgencyReplyBackOnAssessment: [
				'',
				[Validators.required,
				Validators.pattern('^[0-9]{1,2}$'),
				Validators.maxLength(2),
				// Validators.minLength(1),
				// ValidationService.number(6, true)]
				Validators.min(0),
				Validators.max(10)]
			],
			noOfBlockAttempts: [
				'',
				[Validators.required,
				Validators.pattern('^[0-9]{1}$'),
				Validators.maxLength(1),
				// Validators.minLength(1),
				// ValidationService.number(6, true),
				Validators.min(0),
				Validators.max(9)]
			],
			effectiveDate: ['', [Validators.required]],
			rulesForType: this.formBuilder.array([]),
		});
		this.tcTypeFormGroup = this.createRulesForTypeForm();
	}

	createRulesForTypeForm(data?: any) {
		// const educationDetails = this.tcRuleCreationForm.get('tempRuleForType');
		return this.formBuilder.group({
			type: [data ? data.type : '', [Validators.required,	Validators.pattern('^[A-Za-z][A-Za-z \s]*$')]],
			accredationAmount: [data ? data.accredation ? data.accredation.amount : '' : '', []],
			accredationAmountIsRequired: [data ? data.accredation ? data.accredation.isPaymentRequired : '' : '', [Validators.required]],
			continuousMonitoringAmount: [data ? data.continuousMonitoring ? data.continuousMonitoring.amount : '' : '', []],
			continuousMonitoringAmountIsRequired: [data ? data.continuousMonitoring ? data.continuousMonitoring.isPaymentRequired : '' : '',
			[Validators.required]
			],
			unblockingAmount: [data ? data.unBlocking ? data.unBlocking.amount : '' : '', []],
			unblockingAmountIsRequired: [data ? data.unBlocking ? data.unBlocking.isPaymentRequired : '' : '', [Validators.required]],
			affilationAmount: [data ? data.perJobRoleAffiliation ? data.perJobRoleAffiliation.amount : '' : '', []],
			affilationAmountIsRequired: [data ? data.perJobRoleAffiliation ? data.perJobRoleAffiliation.isPaymentRequired : '' : '',
			[Validators.required]],
			appealAmount: [data ? data.appeal ? data.appeal.amount : '' : '', []],
			appealAmountIsRequired: [data ? data.appeal ? data.appeal.isPaymentRequired : '' : '', [Validators.required]],
		});
	}
	addTrainingCentreType() {
		this.tcTypeFormGroup = this.createRulesForTypeForm()
		this.rulesForType = {
			type: '',
			accredation: {
				amount: null,
				isPaymentRequired: ''
			},
			continuousMonitoring: {
				isPaymentRequired: '',
				amount: null
			},
			unBlocking: {
				isPaymentRequired: '',
				amount: null
			},
			perJobRoleAffiliation: {
				isPaymentRequired: '',
				amount: null
			},
			appeal: {
				isPaymentRequired: '',
				amount: null
			}
		};
	}
	addToRuleForType() {
		this.items = this.tcRuleCreationForm.get('rulesForType') as FormArray;
		this.items.push(this.tcTypeFormGroup);
		this.tcRuleDetails.rulesForType.push(this.rulesForType);
		console.log(this.items, 'this.items')
	}
	setValidation(really, control: AbstractControl) {
		really = really === 'Yes' ? true : false;
		let validations = [];
		if (really) {
			validations = [
				Validators.required,
				Validators.pattern('^(([0-9]{1,5})|([0-9]{1,5}[.][0-9]{1,2}))'),
				// ValidationService.number(7, true)
				Validators.maxLength(8),
				// Validators.minLength(1),
				Validators.max(99999.99),
				Validators.min(1)
				// ^[0-9]+$
			];
		}
		control.clearValidators();
		control.setValidators(validations);
		control.updateValueAndValidity();
	}
	removeTrainingCentreType(i) {
		this.items = this.tcRuleCreationForm.get('rulesForType') as FormArray;
		this.items.controls.splice(i, 1);
		this.items.value.splice(i, 1);
		this.tcRuleDetails.rulesForType.splice(i, 1);
	}
	cancelTrainingTypeForm() {
		this.tcTypeFormGroup.reset();
	}
	ngOnInit() {
		this.scriptLoaderService.addScriptTagToElementDOM(
			'../assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js'
		);
		this.isAdmin = this.isAdmin === 'true' ? true : false;
		this.setAdminFormGroup();
		if (this.isAdmin) {
			const userName = this.loggedInUser.userName;
			const role = this.loggedInUser.role;
			this.tcTpCreationService.getTcFormDetails().subscribe(
				(res: any) => {
					if (!res || !res[0]) {
						swal('There is no rule for approval');
						return this.navigateToDashboard();
					}
					// if (!res) return;
					console.log(res[0]);
					const rule = res[0];
					this.tcRuleDetails = rule;
					this.tcRuleDetails.rulesForType = rule.rulesForType;
					// this.tcRuleCreationForm.setValue(rule);
					this.tcRuleCreationForm.get('refundOnDNRIfTCDoesnotReapply')
						.setValue(rule.refundRules.refundOnDNRIfTCDoesnotReapply);
					this.tcRuleCreationForm.get('refundOnSecondDNRIfTCDoesnotReapply')
						.setValue(rule.refundRules.refundOnSecondDNRIfTCDoesnotReapply);
					this.tcRuleCreationForm.get('durationOfBlock')
						.setValue(rule.actionsAndNotifications.durationOfBlock);
					this.tcRuleCreationForm.get('noOfDaysInAdvanceInspectionDateNotifications')
						.setValue(rule.actionsAndNotifications.noOfDaysInAdvanceInspectionDateNotifications);
					this.tcRuleCreationForm.get('noOfDaysForOnsiteInspectionAfterDeemedReady')
						.setValue(rule.actionsAndNotifications.noOfDaysForOnsiteInspectionAfterDeemedReady);
					this.tcRuleCreationForm.get('noOfDaysForInspectionAgencyReplyBackOnAssessment')
						.setValue(rule.actionsAndNotifications.noOfDaysForInspectionAgencyReplyBackOnAssessment);
					this.tcRuleCreationForm.get('noOfBlockAttempts')
						.setValue(rule.actionsAndNotifications.noOfBlockAttempts);
					this.tcRuleCreationForm.get('effectiveDate')
						.setValue(rule.effectiveDate);
					this.tcRuleCreationForm.get('percentageOnRefusalOfCenterInspection')
						.setValue(rule.refundRules.percentageOnRefusalOfCenterInspection[0].percentage);
					this.tcRuleCreationForm.get('percentageOnRefusalOfCenterInspection1')
						.setValue(rule.refundRules.percentageOnRefusalOfCenterInspection[1].percentage);
					this.tcRuleCreationForm.get('percentageOnRefusalOfCenterInspection2')
						.setValue(rule.refundRules.percentageOnRefusalOfCenterInspection[2].percentage);
					const rulesForTypeArray = this.tcRuleCreationForm.get('rulesForType') as FormArray;
					for (let i = 0; i < rule.rulesForType.length; i++) {
						rulesForTypeArray.push(this.createRulesForTypeForm(rule.rulesForType[i]))
					}
					this.ruleId = rule.ruleId;
					const date = this.tcRuleDetails.effectiveDate;
					this.tcRuleDetails.effectiveDate = date
						? Helpers.toCalendarDate(new Date(date))
						: '';
					console.log(this.tcRuleDetails, this.tcRuleCreationForm);
				},
				err => {
					toastr('Something went wrong.');
					return this.navigateToDashboard();
				}
			);
		} else {
			const rulesForTypeArray = this.tcRuleCreationForm.get('rulesForType') as FormArray;
			rulesForTypeArray.push(this.createRulesForTypeForm({ type: 'Reg' }));
			rulesForTypeArray.push(this.createRulesForTypeForm({ type: 'Government' }));
		}
	}

	isDisabled() {
		return this.isAdmin ? '' : null;
	}
	approve(isApprove) {
		this.approved = isApprove;
		this.notApproved = !isApprove;
		this.adminFormGroup.get('approval').setValue(isApprove);
	}

	private setAdminFormGroup() {
		let commentValidation = [];
		let approvalValidation = [];
		if (this.isAdmin) {
			commentValidation = [
				Validators.required,
				Validators.pattern('^[A-Za-z0-9][A-Za-z0-9 \s]*$')
			];
			approvalValidation = [Validators.required];
		}
		this.adminFormGroup = this.formBuilder.group({
			comments: ['', commentValidation],
			approval: ['', approvalValidation]
		});
	}

	saveRule() {
		console.log(this.tcRuleCreationForm, this.tcRuleCreationForm.valid, this.tcRuleDetails.rulesForType)
		if (this.isAdmin) {
			this.onSubmit.emit({
				tcRuleDetails: this.tcRuleDetails,
				details: {
					approverUserName: this.loggedInUser.userName,
					approverUserRole: this.loggedInUser.role,
					status: this.approved ? 'Approved' : 'Not Approved',
					comments: this.comments,
					ruleId: this.ruleId,
					rulesForType : this.tcRuleDetails.rulesForType
				}
			});
		} else {
			const tcRuleDetails = Helpers.copyObj(this.tcRuleDetails);
			let date = this.effectiveDate.nativeElement.value;
			date = date.split('/');
			// date = `${date[1]}-${date[0]}-${date[2]}`;
			date = `${date[2]}-${date[1]}-${date[0]}`;
			tcRuleDetails.effectiveDate = new Date(date).toISOString();
			this.onSubmit.emit({
				tcRuleDetails: tcRuleDetails
			});
		}
	}

	navigateToDashboard() {
		if (this.redirectCancelUrl) {
			this.router.navigate([this.redirectCancelUrl]);
		}
		// if (this.isAdmin) {
		// 	this.router.navigate(['../smartadmin']);
		// } else {
		// 	this.router.navigate(['../smartbusiness']);
		// }
	}
}
